import config from '@/config';
import { format, parse } from 'date-fns';
import ru from 'date-fns/locale/ru';

export default function toVerbalDateFilter(
  date,
  formatStr = config.dateInputFormat
) {
  const parsedDate = parse(date, formatStr, new Date());
  const outputFormat =
    format(parsedDate, 'yyyy') !== new Date().getFullYear()
      ? 'dd MMMM yyyy'
      : 'dd MMMM';
  return format(parsedDate, outputFormat, { locale: ru });
}
